<template>
	<v-app
		id="app"
		:class="{
			transparent: isTransparentBackground,
			'is-external-dialog': isExternalDialog,
			'dialog-active': isDialogOpen,
			[osTypeClass]: true,
			'settings-dialog-active': isSettingsDialogOpen,
		}"
	>
		<v-main>
			<router-view></router-view>
		</v-main>
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex';

import { isDialogActive, getOpenDialogs } from './store/modules/dialogs/getters';
import UserAgentService from './utils/user-agent-service';
import { APP_DIALOG_NAMES } from '@/components/dialogs/AppDialogManager/app-dialog-manager.const.js';
import AnalyticsService from '@/utils/AnalyticsService';
const osClassTypeMap = {
	Win: 'windows-os-type',
	X11: 'unix-os-type',
	Linux: 'linux-os-type',
	Mac: 'mac-os-type',
};

export default {
	name: 'App',
	computed: {
		...mapGetters(['isLoggedIn', isDialogActive.fullPath, getOpenDialogs.fullPath]),
		openDialogs() {
			return this[getOpenDialogs.fullPath];
		},
		isTransparentBackground() {
			return ['WidgetView', 'PrivacySettingsPage'].includes(this.$route.name);
		},
		isExternalDialog() {
			return this.$route.path.includes('external-dialog');
		},
		isDialogOpen() {
			return this[isDialogActive.fullPath];
		},
		osTypeClass() {
			const { name } = UserAgentService.getOS();
			const osType = Object.keys(osClassTypeMap).filter((key) => name.toLowerCase().includes(key.toLowerCase()));
			return osClassTypeMap[osType];
		},
		isSettingsDialogOpen() {
			return this.openDialogs?.some((dialog) => dialog.dialogName === APP_DIALOG_NAMES.SETTINGS_DIALOG);
		},
	},
	watch: {
		$route(to) {
			AnalyticsService.trackPageVisited(to);
		},
	},
};
</script>

<style lang="scss">
@import './assets/css/main.css';
@import './styles/main.scss';

#app.transparent {
	background: transparent;
}
#app.is-external-dialog {
	background: transparent;
}
#app.is-external-dialog .project-top-bar {
	display: none;
}

#app.settings-dialog-active {
	height: 90vh;
	max-height: 800px;
	border-radius: 8px;
}
</style>
